export const handleResponse = (data) => {
    return new Promise.resolve(data);
};

export const handleError = (err) => {
    return err.response.data;
};
